//FEATURES
export const SYPI_S3 = "SYPIS3";
export const SYPI_SERVER_SETTINGS = "SYPI_SERVER_SETTINGS";
export const SYPI_DB = "SYPI_DB";
export const CONFIG_SCHEDULER = "CONFIG_SCHEDULER";
export const SYPI_LEGACY = "SYPI_LEGACY";
// Sypi actions
export const LOAD_SYPI_DB = "LOAD_SYPI_DB";
export const INITIAL_PAYLOAD = "INITIAL_PAYLOAD";
export const LOG_CHANGE_DICT = "LOG_CHANGE_DICT";
export const SET_SYPI_SERVER_SETTINGS = "SET_SYPI_SERVER_SETTINGS";
export const UPDATE_SYPI_SOURCE_OF_TRUTH = "UPDATE_SYPI_SOURCE_OF_TRUTH";
export const LOAD_SYPI_SCHEMA = "LOAD_SYPI_SCHEMA";
export const LOAD_SYPI_MASTER_SCHEMA = "LOAD_SYPI_MASTER_SCHEMA";
export const CLEAR_SYPI_S3 = "CLEAR_SYPI_S3";

export const SET_REHYDRATE = "SET_REHYDRATE";
export const LOAD_DEFAULT_CONFIG = "LOAD_DEFAULT_CONFIG";
export const MERGE_DEFAULT_CONFIG = "MERGE_DEFAULT_CONFIG";
export const SET_SYPI_DETAILS = "SET_SYPI_DETAILS";
export const UPDATE_SYPI_DETAILS = "UPDATE_SYPI_DETAILS";
export const SET_FEATURE = "SET_FEATURE";
export const SET_BUSINESS_RULES = "SET_BUSINESS_RULES";
export const SET_INSTANCE = "SET_INSTANCE";
export const SET_CONTENT = "SET_CONTENT";
export const SET_ENTIRE_CONFIG = "SET_ENTIRE_CONFIG";
export const SET_STYLE_CONFIG = "SET_STYLE_CONFIG";
export const LOG_CHANGES = "LOG_CHANGES";
export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";
export const SELECT_ACTION_TAB = "SELECT_ACTION_TAB";
export const SET_CLIENT_VISIBILITY = "SET_CLIENT_VISIBILITY";

export const LOAD_SCHEDULED_DRAFT_SET = "LOAD_SCHEDULED_DRAFT_SET";
export const LOAD_SCHEDULED_DRAFT = "LOAD_SCHEDULED_DRAFT";
export const LOAD_INITIAL_SCHEDULED_DRAFT = "LOAD_INITIAL_SCHEDULED_DRAFT";
export const LOAD_CONFIG_SCHEDULER_HISTORY = "LOAD_CONFIG_SCHEDULER_HISTORY";
export const SET_SCHEDULED_HISTORY_VIEW = "SET_SCHEDULED_HISTORY_VIEW";
export const SET_SYPI_CONFIG_NAME = "SET_SYPI_CONFIG_NAME";
export const SET_SYPI_CONFIG_SAVE_STATE = "SET_SYPI_CONFIG_SAVE_STATE";
export const SET_SYPI_CONFIG_STATUS = "SET_SYPI_CONFIG_STATUS";
export const SET_SUMMARY_VIEW_TYPE = "SET_SUMMARY_VIEW_TYPE";
export const TOGGLE_SUMMARY_CONFIRM = "TOGGLE_SUMMARY_CONFIRM";
export const RESET_SYPI_SCHEDULER_SET_UP = "RESET_SYPI_SCHEDULER_SET_UP";

export const SET_FM_LINK = "SET_FM_LINK";
export const REMOVE_FM_LINK = "REMOVE_FM_LINK";
export const CLEAR_FM_LINKS = "CLEAR_FM_LINKS";
export const SET_FM_LINK_BUCKET = "SET_FM_LINK_BUCKET";
export const SET_FM_LINK_EDITING_MODE = "SET_FM_LINK_EDITING_MODE";
export const SET_FM_LINK_LIST = "SET_FM_LINK_LIST";

// Global actions
export const MODIFY_PAYLOAD = "MODIFY_PAYLOAD";
export const CLICK_TAB = "CLICK_TAB";
export const CLICK_SUB_TAB = "CLICK_SUB_TAB";
export const INITIAL_TABS_STATE = "INITIAL_TABS_STATE";
export const DISABLE_ENABLE_TAB = "DISABLE_ENABLE_TAB";
export const RESET_TABS = "RESET_TABS";
export const RESET_SPECIFIC_TAB = "RESET_SPECIFIC_TAB";
export const SET_TAB_ERRORS = "SET_TAB_ERRORS";
export const ENABLE_POST = "ENABLE_POST";
export const ENABLE_SAVE = "ENABLE_SAVE";
export const DISABLE_SAVE = "DISABLE_SAVE";
export const ENABLE_MODEL = "ENABLE_MODEL";
export const CLEAR_CHANGES = "CLEAR_CHANGES";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_FILTER_PARAM = "SET_FILTER_PARAM";
export const SET_SORT_PARAM = "SET_SORT_PARAM";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const SET_TITLE = "SET_TITLE";
export const SET_NEW_DATE = "SET_NEW_DATE";
export const SET_NEW_TIME = "SET_NEW_TIME";
export const SET_MODIFIED_DATE = "SET_MODIFIED_DATE";
export const SET_ERROR = "SET_ERROR";
export const CLEAR_LOG = "CLEAR_LOG";
export const SET_FIELD_VISIBILITY = "SET_FIELD_VISIBILITY";
export const SEARCH = "SEARCH";
export const LOAD_PAYLOAD = "LOAD_PAYLOAD";
export const LOAD_FLAT_PAYLOAD = "LOAD_FLAT_PAYLOAD";


export type GlobalActionType =
  | typeof INITIAL_PAYLOAD
  | typeof MODIFY_PAYLOAD
  | typeof CLICK_TAB
  | typeof CLICK_SUB_TAB
  | typeof INITIAL_TABS_STATE
  | typeof DISABLE_ENABLE_TAB
  | typeof RESET_TABS
  | typeof RESET_SPECIFIC_TAB
  | typeof SET_TAB_ERRORS
  | typeof ENABLE_POST
  | typeof ENABLE_SAVE
  | typeof DISABLE_SAVE
  | typeof ENABLE_MODEL
  | typeof CLEAR_CHANGES
  | typeof CLEAR_ERRORS
  | typeof SET_FILTER_PARAM
  | typeof SET_SORT_PARAM
  | typeof TOGGLE_MODAL
  | typeof SET_TITLE
  | typeof SET_NEW_DATE
  | typeof SET_NEW_TIME
  | typeof SET_MODIFIED_DATE
  | typeof SET_ERROR
  | typeof CLEAR_LOG
  | typeof SET_FIELD_VISIBILITY
  | typeof SEARCH
  | typeof LOAD_PAYLOAD
  | typeof LOAD_FLAT_PAYLOAD;